import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  template: ''
})
export abstract class AbstractSettingsFilteredTableComponent<T> implements AfterViewInit {

  @ViewChild(MatSort)
  sort: MatSort | null;

  abstract dataSource: MatTableDataSource<T>;

  constructor() {
    this.sort = null;
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  };

}
